import { useParams, useLocation } from "react-router-dom";
import ListViewLayout from "../layout/ListViewLayout";

function ListView({ socket, selectedWhatsAppSetting }) {
  const { objectName } = useParams();
  const location = useLocation();
  console.log("Object Edit Wrapper-->", objectName);
  console.log("ListView URL parameters:", location.search);
  return (
    <ListViewLayout
      objectName={objectName}
      location={location}
      socket={socket}
      selectedWhatsAppSetting={selectedWhatsAppSetting}
    />
  );
}
export default ListView;
